class SteelhomeShelfProduct extends HTMLElement {
  connectedCallback() {
    this.gallery();
    this.installation();
  }
  makeCarousel(root, slides, controls, delay) {
    if (!root || slides.length < 2) return;
    let index = 0;
    let timer;
    let startX = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      controls.forEach((control, i) => control.classList.toggle('is-active', i === index));
    };
    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => show(index + 1), delay);
    };
    controls.forEach((control, i) => control.addEventListener('click', () => { show(i); start(); }));
    root.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      stop();
      root.setPointerCapture?.(event.pointerId);
    });
    root.addEventListener('pointerup', (event) => {
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 40) show(index + (distance < 0 ? 1 : -1));
      start();
    });
    root.addEventListener('pointercancel', start);
    start();
    return { show, start, stop, getIndex: () => index };
  }
  gallery() {
    const stage = this.querySelector('.shp-stage');
    const images = [...this.querySelectorAll('[data-gallery-image]')];
    const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    this.makeCarousel(stage, images, thumbs, 4500);
  }
  installation() {
    const root = this.querySelector('[data-install-carousel]');
    if (!root) return;
    const slides = [...root.querySelectorAll('[data-install-slide]')];
    const dots = [...root.querySelectorAll('[data-install-dot]')];
    const carousel = this.makeCarousel(root, slides, dots, 5000);
    if (!carousel) return;
    root.querySelector('[data-install-prev]')?.addEventListener('click', () => { carousel.show(carousel.getIndex() - 1); carousel.start(); });
    root.querySelector('[data-install-next]')?.addEventListener('click', () => { carousel.show(carousel.getIndex() + 1); carousel.start(); });
    root.addEventListener('focusin', carousel.stop);
    root.addEventListener('focusout', carousel.start);
  }
}
if (!customElements.get('steelhome-shelf-product')) customElements.define('steelhome-shelf-product', SteelhomeShelfProduct);
